<template>
  <div class="modal fade" id="addPage" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Add Page</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <label class="form-label">Page Name</label>
          <div class="input-group">
            <input v-model="pagesForm.pageName" class="form-control" required>
          </div>
        </div>
        <div class="modal-footer">
          <div v-if="pagesForm.pageId != '' " class="text-end mt-2" style="border-top: 1px solid #f3f3f3">
            <button class="btn" @click="TryAddProjectRole()" data-bs-dismiss="modal" style="background-color: #499c4a;color: #ffffff">
              <font-awesome-icon icon="edit"/>
              <span class="mx-1">Update</span>
            </button>
          </div>
          <div v-else class="text-end mt-2" style="border-top: 1px solid #f3f3f3">
            <button class="btn" @click="TryAddProjectRole()" data-bs-dismiss="modal" style="background-color: #56759c;color: #ffffff">
              <font-awesome-icon icon="save"/>
              <span class="mx-1">Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapState} from "vuex"
    export default {
        name: "AddPage",
        props: ['isActiveProjectPageModal', 'projectId','pagesForm', 'pageId'],
        components:{
        },
        data() {
            return {
              userForm: {
                userId: [],
                projectId: 0,
              },
              pageForm: {
                id: 0,
                pageName: "",
                projectId: 0,
                isDeleted:false

              }
            }
        },
        computed: {
          ...mapState('projects', ['userProject']),
          ...mapState('users' , ['userList']),
        },
        methods: {
           ...mapActions('users', ["getUsers"]),
           ...mapActions('projects', ['getProjects', 'getProject', 'getUserProject', 'addUserProject', 'addProject', 'openCloseProjectModal', 'deleteUser']),
           ...mapActions('pages', ['getProjectPages','getPageResources','deletePage','addPage']),

          openClosePageModal() {
                this.pageForm.pageName = "";
                this.$emit('openClosePageModal');
            },
            async TryAddProjectRole() {
              try {
                this.pageForm.projectId = parseInt(this.projectId);
                this.pageForm.id = parseInt(this.pagesForm.pageId);
                this.pageForm.pageName = this.pagesForm.pageName;
                await this.addPage(this.pageForm);
                await this.getProjectPages(this.pageForm.projectId);
                await this.openClosePageModal();
                this.$notify({title: "Success", type: "success", text: "Successfully added page."})
              } catch (e) {
                this.$notify({title: "Error", type: "error", text: e})
              }
            },
        },
        mounted() {
          document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27)//ESC
                {
                    this.isActiveProjectPageModal = false;
                }
            })
        },
      created() {
          this.getUsers();
      }
    }
</script>

<style scoped>
  .modal-footer{
    background-color: #eff1f3;
  }
</style>
